import React from 'react'
import classNames from 'classnames'
import Check from 'images/inline/spot-the-diff/check.svg'
import Error from 'images/inline/spot-the-diff/error.svg'

const IconMapper = {
  found: <Check />,
  cantFind: <Error />,
}

export const Difference = ({ id, type, onImage, style }) => {
  const differenceClass = classNames('difference', {
    correct: type === 'found',
    incorrect: type === 'cantFind',
    image: onImage,
  })

  return (
    <div id={id} className={differenceClass} style={style}>
      {IconMapper[type]}
    </div>
  )
}
